import { Input, KeyCode } from "../../lib/Input";
import SPAbility from "../SPAbility";
import SPBullet from "../SPBullet";
import SPGameManager from "../SPGameManager";
import SPPlayer from "../SPPlayer";

export default class SPOverchargedShot extends  SPAbility {

    constructor(player: SPPlayer) {
        super(player, {
            cooldown: 24,
            duration: 0,
            icon: 8,
            trigger: KeyCode.Digit1,
            triggerType: Input.GetKeyDown
        });
    }

    onUse(): void {
        this.player.gun.isOvercharged = true;
        SPGameManager.Singleton.crosshairSize = 6;
    }

}